import { Icon, IStyle } from '@fluentui/react';
import { forwardRef, ReactNode, Ref } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { linkStylesDefault } from '../Link/Link.styles';

export interface IRouterLinkProps extends LinkProps, IComponent<IRouterLinkStyles> {
  iconName?: string;
  children?: ReactNode;
}

interface IRouterLinkStyles {
  root: IStyle;
}

interface IRouterLinkClassNames {
  root: string;
}

// When Link component of Fluent uses `href`, it is normal link and it reloads the whole page.
// When Link component of Router uses `href` with the router path, it doesn't reload the whole page. it works like history.push(xx).
// So, when you use the external link, use `Link`. when you use the router path, use `RouterLink`
// It can be a part of a logic of our `Link` component, but it is made separately for less complexity.
// The element structure is almost the same as `Link` component, so it re-used the styles of `Link` component
export const RouterLink = forwardRef((props: IRouterLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const { iconName, className, styles, children, ..._fProps } = props;
  const classNames = useClassNames<IRouterLinkStyles, IRouterLinkClassNames>(
    'RouterLink',
    linkStylesDefault,
    styles,
    className
  );
  const fProps: LinkProps = {
    ..._fProps,
  };
  return (
    <Link {...fProps} className={classNames.root} ref={ref} data-test={props['data-test'] || 'router-link'}>
      {iconName && <Icon className="Link-icon" iconName={iconName} />}
      <span className="Link-text">{children}</span>
    </Link>
  );
});
